import { render } from "./QuoteLegalTranslation.vue?vue&type=template&id=231e2c1b&scoped=true"
import script from "./QuoteLegalTranslation.vue?vue&type=script&lang=js"
export * from "./QuoteLegalTranslation.vue?vue&type=script&lang=js"

import "./QuoteLegalTranslation.vue?vue&type=style&index=0&id=231e2c1b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-231e2c1b"

export default script